var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 512,
    height: 512,
    fill: "#338af3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M360.727,266.662H151.273c0,14.461,12.594,26.182,27.054,26.182h-.872a26.181,26.181,0,0,0,26.182,26.182,26.181,26.181,0,0,0,26.182,26.182h52.363a26.181,26.181,0,0,0,26.182-26.182,26.181,26.181,0,0,0,26.182-26.182h-.872C348.132,292.844,360.727,281.122,360.727,266.662Z",
    fill: "#ffda44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M328.5,232.423a72.5,72.5,0,1,1-145.008,0",
    fill: "#338af3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M327.871,225.638,298.5,237.528l15.638,24.48-31.889-5.251-4.041,27.727L256,264.092l-22.213,20.392-4.04-27.727-31.889,5.25,15.637-24.48-29.366-11.889L213.5,213.749,197.858,189.27l31.889,5.25,4.041-27.727L256,187.185l22.213-20.392,4.04,27.727,31.89-5.25-15.638,24.48Z",
    fill: "#ffda44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKk);
export default __webpack_public_path__ + "static/media/kk.b7fc2afae934a0e7ffddd90f0c33c1d0.svg";
export { ForwardRef as ReactComponent };